import axios from "axios";
import { getAppBaseURL } from "./networkUtil";

const AXIOS_TIMEOUT = { timeout: 15 * 1000 * 60 };

const SERVER_BASE_URL = process.env.REACT_APP_URL + "/advisor/api/v1/";

const validateStatusFn = function (status) {
  return status >= 200 && status <= 422; // Treat status codes 200-299 as successful
};

const AxiosInstance = axios.create({
  baseURL: `${SERVER_BASE_URL}`,
  timeout: AXIOS_TIMEOUT,
  validateStatus: validateStatusFn,
});
/**
 * Request interceptor — dynamic baseURL rewrite.
 *
 * Most requests use an app-scoped base URL derived from the current route.
 * Request callers can override this by passing `overrideAppScope`
 * with one of: "ca", "ra", or "base".
 * If `overrideAppScope` is not provided, scope is auto-detected from route.
 *
 * However, some API calls (e.g. getadvanceSettings / setadvanceSettings)
 * are app-agnostic (shared across base, ca & ra).
 * Those callers pass `overrideAppScope: "base"` to preserve
 * the plain /advisor/api/v1/ base.
 */
AxiosInstance.interceptors.request.use((config) => {
  const { overrideAppScope } = config;
  config.baseURL = getAppBaseURL(overrideAppScope);
  return config;
});

// Reinitiate SSO when a 401 error occurs on any network request.
// Note: validateStatusFn treats status codes 200–422 as success,
// so 401 must be handled in the response interceptor.
// Redirecting to the home page ensures that all required network requests are triggered,
// as some(e.g., getPlant API) may not fire if we stay on the same page.
// We also need to restart the PKCE flow; without it, the code challenge is missing error occurs
// A full page reload will trigger SSO reinitialization.
AxiosInstance.interceptors.response.use((response) => {
  if (response.status === 401) {
    console.log("Axios error:", response);
    sessionStorage.clear();
    window.location.href = process.env.REACT_APP_REDIRECT_URI;
  }
  return response;
});

export const AxiosInstanceWithoutTimeout = axios.create({
  baseURL: `${getAppBaseURL()}`,
});

export default AxiosInstance;
